export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
}
